import { createFileRoute, useParams } from "@tanstack/react-router";
import { BatchClearanceDefinitionEditor } from "@/features/batch-clearance-definition-editor";
import { z } from "zod";
import { BatchClearanceDefinitionId } from "@brewbase/db/types";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute(
  "/settings/batch-clearance/$clearance_defintion_id",
)({
  component: () => (
    <RequireCapability cap="batch-clearance:configure">
      <RouteComponent />
    </RequireCapability>
  ),
  // Validate that clearance_defintion_id is a number and cast it to BatchClearanceDefinitionId
  parseParams: (params: { clearance_defintion_id: string }) => ({
    clearance_defintion_id: z.coerce
      .number()
      .transform((val) => val as BatchClearanceDefinitionId)
      .parse(params.clearance_defintion_id),
  }),
  // Stringify params for link generation (optional but good practice)
  stringifyParams: (params: {
    clearance_defintion_id: BatchClearanceDefinitionId;
  }) => ({
    clearance_defintion_id: params.clearance_defintion_id.toString(),
  }),
});

function RouteComponent() {
  const { clearance_defintion_id } = Route.useParams();

  return (
    <div className="container mx-auto px-4 pt-2 flex flex-col grow min-h-0">
      <BatchClearanceDefinitionEditor definitionId={clearance_defintion_id} />
    </div>
  );
}
